import { MdStorage } from '@teamworksdev/icons';
import { useTranslation } from 'react-i18next';
import { DataTablePlaceholder } from './data-table-placeholder';

export const DefaultNoDataPlaceholder = () => {
  const { t } = useTranslation();
  return (
    <DataTablePlaceholder icon={<MdStorage size={24} />} title={t('noData')} />
  );
};
